import { useEffect } from 'react';

export const BOOKING_SECTION_ID = 'booking';
export const BOOKING_SECTION_HASH = `#${BOOKING_SECTION_ID}`;

export const scrollToBookingSection = () => {
  if (typeof document === 'undefined') {
    return false;
  }

  const bookingSection = document.getElementById(BOOKING_SECTION_ID);
  if (!bookingSection) {
    return false;
  }

  bookingSection.scrollIntoView({
    behavior: 'smooth',
    block: 'start',
  });
  return true;
};

/**
 * Scroll to the booking form after the listing has loaded. Routes also handles
 * hashes globally, but the listing can render after that router-level attempt.
 */
export const useScrollToBookingSection = ({ hash, listingId }) => {
  useEffect(() => {
    if (hash !== BOOKING_SECTION_HASH || !listingId || typeof window === 'undefined') {
      return undefined;
    }

    let retryTimer;
    let animationFrame;

    const scrollWhenReady = () => {
      if (!scrollToBookingSection()) {
        retryTimer = window.setTimeout(scrollToBookingSection, 300);
      }
    };

    if (typeof window.requestAnimationFrame === 'function') {
      animationFrame = window.requestAnimationFrame(scrollWhenReady);
    } else {
      scrollWhenReady();
    }

    return () => {
      if (animationFrame != null && typeof window.cancelAnimationFrame === 'function') {
        window.cancelAnimationFrame(animationFrame);
      }
      if (retryTimer != null) {
        window.clearTimeout(retryTimer);
      }
    };
  }, [hash, listingId]);
};
